module.exports = __webpack_public_path__ + "static/media/owl-02.df4458eb.svg";